import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as certificadoActions from '@catalogo/features/compartilhado/usuario-certificado';
import { Store } from '@ngxs/store';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { ApiResult, LocalStorageUtil, NotificationService } from 'ui-shared';
import { PortalUnicoValidacaoResult } from "@catalogo/models";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import {
    UsuarioCertificadoSelector
} from "@catalogo/features/compartilhado/usuario-certificado/usuario-certificado-store/usuario-certificado.selectors";
import {
    DadosAutenticacaoPortalUnico
} from "@catalogo/features/compartilhado/usuario-certificado/DadosAutenticacaoPortalUnico";
import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";

@Injectable({
    providedIn: 'root'
})
export class PortalUnicoIntegracaoService {
    
    url: string;
    constructor(
        @Inject(OPERACAO_API_URL) public urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient,
        private notification: NotificationService,
        private store: Store
    ) {
    
    }
    
    integrarOperadorEstrangeiro = (operadorEstrangeiroId: string, versaoId: string) =>
        this.post(`${this.urlBase}/v1/operadorestrangeiro/${operadorEstrangeiroId}/versao/${versaoId}/integrarPortalUnico`, null);
    
    enviarFabricanteProduto = (produtoId: string, fabricanteId: string) =>
        this.post(`${this.urlBase}/v1/Produto/${produtoId}/Fabricante/${fabricanteId}/EnviarPortalUnico`, null);
    
    removerFabricanteProduto = (produtoId: string, fabricanteId: string) =>
        this.post(`${this.urlBase}/v1/Produto/${produtoId}/Fabricante/${fabricanteId}/RemoverPortalUnico`, null);
    
    enviarFabricanteProdutoIndividual = (fabricanteId: string, produtoFabricanteEmpresaId: string) =>
        this.post(`${this.urlBase}/v1/Produto/Fabricante/${fabricanteId}/Empresa/${produtoFabricanteEmpresaId}/EnviarPortalUnico`, null);
    
    removerFabricanteProdutoIndividual = (fabricanteId: string, produtoFabricanteEmpresaId: string) =>
        this.post(`${this.urlBase}/v1/Produto/Fabricante/${fabricanteId}/Empresa/${produtoFabricanteEmpresaId}/RemoverPortalUnico`, null);
    
    integrarVersaoProduto = (produtoId: string, versaoId: string) =>
        this.post(`${this.urlBase}/v1/Produto/${produtoId}/versao/${versaoId}/integrarPortalUnico`, null);
    
    integrarProdutoVersoes = (listaProdutos: string[]) =>
        this.post(`${this.urlBase}/v1/Produto/versao/IntegrarPendentesPortalUnico`, {listaProdutos: listaProdutos});
    
    private post = (url: string, data: any): Observable<any> => {
        return this.obtemTokenAcesso()
            .pipe(
                switchMap((dadosPortalUnico) => {
                    if (<EnumTipoAutenticacaoEnvioPortalUnico>dadosPortalUnico.tipoAutenticacao != EnumTipoAutenticacaoEnvioPortalUnico.Padrao
                        && (!dadosPortalUnico.accessToken || !dadosPortalUnico.xCSRFToken)) {
                        LocalStorageUtil.removerDadosPortalUnico();
                        this.notification.openError("Não foi possível autenticar no Portal Único.");
                        return EMPTY;
                    }
                    
                    const headers = <EnumTipoAutenticacaoEnvioPortalUnico>dadosPortalUnico.tipoAutenticacao != EnumTipoAutenticacaoEnvioPortalUnico.Padrao ?
                        {
                            'AccessToken': dadosPortalUnico.accessToken,
                            'XcsrfToken': dadosPortalUnico.xCSRFToken,
                            'XcsrfExpiration': dadosPortalUnico.xCSRFExpiracao
                        } :
                        null;
                    
                    let body = { ...data, tipoAutenticacao: <EnumTipoAutenticacaoEnvioPortalUnico>dadosPortalUnico.tipoAutenticacao };
                    
                    if (data instanceof Array) {
                        body = data;
                    }
                    
                    return this.httpClient.post<ApiResult<PortalUnicoValidacaoResult>>(url, body, {
                        headers: headers
                    }).pipe(
                        tap(resposta => {
                            if (dadosPortalUnico.tipoAutenticacao == EnumTipoAutenticacaoEnvioPortalUnico.Usuario) {
                                if (!resposta.data.xcsrfToken) {
                                    LocalStorageUtil.removerDadosPortalUnico();
                                } else {
                                    LocalStorageUtil.atualizarXcsrfToken(resposta.data.xcsrfToken, resposta.data.xcsrfExpiration);
                                }
                            }
                        })
                    )
                }),
            );
    }
    
    private obtemTokenAcesso(): Observable<DadosAutenticacaoPortalUnico> {
        const dadosPortalUnico = LocalStorageUtil.obterDadosPortalUnico();
        const tokenValido = dadosPortalUnico.accessToken && Date.parse(dadosPortalUnico.xCSRFExpiracao) > Date.now();
        
        return this.store.dispatch(new certificadoActions.Existe()).pipe(
            switchMap(() =>
                this.store.dispatch(new certificadoActions.AbrirModalSenha(true, !tokenValido)).pipe(
                    switchMap( () =>
                        this.store.select(UsuarioCertificadoSelector.modalSenhaConfirmado).pipe(
                            take(1),
                            switchMap( confirmado => {
                                if(confirmado){
                                    let dadosPortalUnico = LocalStorageUtil.obterDadosPortalUnico();
                                    return this.store.select(UsuarioCertificadoSelector.tipoAutenticacaoSelecionado).pipe(
                                        take(1),
                                        switchMap(tipoAutenticacaoSelecionada => {
                                            return of({ ...dadosPortalUnico, tipoAutenticacao: tipoAutenticacaoSelecionada });
                                        })
                                    );
                                }
                                return EMPTY;
                            })
                        ))
                )
            )
        );
    }
}
